"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFolderMessageKind = exports.EFolderMessageAuthorSide = void 0;
const classTransformer_1 = require("../classTransformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
var EFolderMessageAuthorSide;
(function (EFolderMessageAuthorSide) {
    EFolderMessageAuthorSide["OFFICE"] = "OFFICE";
    EFolderMessageAuthorSide["MEMBER"] = "MEMBER";
})(EFolderMessageAuthorSide || (exports.EFolderMessageAuthorSide = EFolderMessageAuthorSide = {}));
var EFolderMessageKind;
(function (EFolderMessageKind) {
    EFolderMessageKind["TEXT"] = "TEXT";
    EFolderMessageKind["ANCHOR"] = "ANCHOR";
})(EFolderMessageKind || (exports.EFolderMessageKind = EFolderMessageKind = {}));
class FolderMessage extends Resource_1.default {
}
exports.default = FolderMessage;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderMessage.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderMessage.prototype, "conversation_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(EFolderMessageAuthorSide),
    __metadata("design:type", String)
], FolderMessage.prototype, "author_side", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderMessage.prototype, "author_user_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderMessage.prototype, "author_display_name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(EFolderMessageKind),
    __metadata("design:type", String)
], FolderMessage.prototype, "kind", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createMessage", "updateMessage"], message: "Message content is required" }),
    (0, class_validator_1.IsString)({ groups: ["createMessage", "updateMessage"] }),
    (0, class_validator_1.MaxLength)(5000, { groups: ["createMessage", "updateMessage"], message: "Message content is too long" }),
    __metadata("design:type", String)
], FolderMessage.prototype, "content", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderMessage.prototype, "anchor_document_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], FolderMessage.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], FolderMessage.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], FolderMessage.prototype, "recipient_read_at", void 0);
